import { c as _c } from "react/compiler-runtime";
import React, { type ReactElement } from 'react';
import Notification from '../Notification';
import { type NotificationProps } from '../Notification/types';
import { StyledNotificationBadgeContainer, StyledNotificationContainer } from './styles';
interface NotificationBadgeProps {
  /** The content to wrap with a notification badge. */
  children: ReactElement<any, any>;
  /** The value to display in the notification badge, and the type of badge */
  notificationProps: NotificationProps;
}

/**
 * A wrapper component that adds a notification badge to its children.
 * The badge appears in the top-right corner of the wrapped element.
 */
const NotificationBadge: React.FC<NotificationBadgeProps> = t0 => {
  const $ = _c(5);
  const {
    children,
    notificationProps
  } = t0;
  let t1;
  if ($[0] !== notificationProps) {
    t1 = (!isNaN(Number(notificationProps.value)) ? Number(notificationProps.value) > 0 : true) && <StyledNotificationContainer><Notification {...notificationProps} /></StyledNotificationContainer>;
    $[0] = notificationProps;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== t1) {
    t2 = <StyledNotificationBadgeContainer>{children}{t1}</StyledNotificationBadgeContainer>;
    $[2] = children;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export default NotificationBadge;
export { NotificationBadge };